import request from '@/modules/base/util/request'

import config from 'config'
import { pickBy } from 'lodash'

const baseUrl = `${config.resourceHost}`

export const ClientService = {
  create: (client) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}client`, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data: client,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },

  edit: (client) => {
    return new Promise((resolve, reject) => {
      const { id } = client
      request(`${baseUrl}client/${id}`, {
        method: 'PUT',
        auth: true,
        isConcurrent: true,
        data: client,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },

  getById: (id) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}client/${id}`, {
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },

  getAllSSR: (options) => {
    const { offset = 0, limit, searchTerm, orderBy } = options
    const dataToSend = {
      startRow: offset,
      endRow: limit ? offset + limit : null,
      searchTerm,
      sortModel: orderBy || [],

    }

    return new Promise((resolve, reject) => {
      const url = `${baseUrl}clients`
      return request(url, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        timeout: config.requestExtraLongTimeout,
        data: dataToSend,
      }).then(response => {
        const { body } = response
        resolve(body)
      })
        .catch(error => reject(error))
    })
  },

  delete: (id) => {
    return new Promise((resolve, reject) => {
      return request(`${baseUrl}client/${id}`, {
        auth: true,
        isConcurrent: true,
        method: 'DELETE',
      })
        .then((result) => resolve(result))
        .catch(error => reject(error))
    })
  },

  find: async(searchTerm, offset = null, limit = null, tenantCollaborationId) => {
    try {
      const query = new URLSearchParams(pickBy({ limit, offset, tenantCollaborationId }, Boolean))
      const { body } = await request(`${baseUrl}find/client/${searchTerm || '*'}?${query.toString()}`, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
      return body
    } catch (error) {
      throw error
    }
  },
}

export default ClientService
